import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, catchError, map, of } from 'rxjs';
import {TokenService} from "../../../services/token-service/token.service";
import {SessionService} from "../../../services/session-service/session.service";
import {CognitoAuthService} from "../../auth/cognito/cognito-auth.service";

@Injectable({
  providedIn: 'root'
})
export class SessionGuard implements CanActivate {
  private token = inject(TokenService);
  private session = inject(SessionService);
  private cognito = inject(CognitoAuthService);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);


  constructor() {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    if(!this.session.user?.perfil){
      this.session.setUser()
    }

    if(!this.token.issetToken()){
      this.session.logout(this.verifyPageReturn(state.url));
    }

    if (!this.token.checkExp()){
      // Access do Cognito vale 1h contra 15 dias do JWT legado. Expirar aqui é
      // rotina, não fim de sessão: o refresh vale 30 dias.
      if (this.cognito.ehSessaoDoCognito()) {
        return this.cognito.renovar().pipe(
          map(() => {
            this.session.setUser();
            return true;
          }),
          catchError(() => {
            this.session.logout(this.verifyPageReturn(state.url));
            return of(true);
          }),
        );
      }
      this.session.logout(this.verifyPageReturn(state.url));
    }

    return true;
  }

  verifyPageReturn(targetUrl?: string): string | undefined {
    // Priorize a URL de destino que o Router está tentando ativar (state.url),
    // pois window.location ainda aponta para a rota atual (pode não ser /private).
    const fullPath = targetUrl || (window.location.pathname + (window.location.search || ''));
    if (fullPath && fullPath.startsWith('/')) {
      const encoded = encodeURIComponent(fullPath);
      // Redireciona diretamente para a rota de login com o parâmetro codificado,
      // evitando estados intermediários na home e problemas de query quebrada.
      return `/login?returnTo=${encoded}`;
    }
    return undefined;
  }
}
